import { useQuery, type QueryKey } from "@tanstack/react-query";
import { apiRequest } from "./api";

export function useResource<T>(
  key: QueryKey,
  path: string,
  developmentFallback: T,
) {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      try {
        return (await apiRequest<T>(path)).data;
      } catch (error) {
        if (import.meta.env.DEV) return developmentFallback;
        throw error;
      }
    },
    staleTime: 30_000,
  });
}

